
<div class="progress">
  <div
    class="progress-bar progress-bar-striped"
    role="progressbar"
    :aria-valuenow="value"
    :aria-valuemin="min"
    :aria-valuemax="max"
    :style="styles"
    :class="barClasses"
  ></div>
</div>
